export function remToPx(value: string) {
  return Math.round(parseFloat(value) * 16);
}

export function pxToRem(value: number) {
  return `${value / 16}rem`;
}

export function responsiveFontSizes({ sm, md, lg }: { sm: number; md: number; lg: number }) {
  return {
    '@media (min-width:901px)': { fontSize: pxToRem(lg) },
    '@media (max-width:900px)': { fontSize: pxToRem(md) },
    '@media (max-width:600px)': { fontSize: pxToRem(sm) },
  };
}

declare module '@mui/material' {
  interface TypographyVariants {
    fontSecondaryFamily: React.CSSProperties['fontFamily'];
    fontWeightSemiBold: React.CSSProperties['fontWeight'];
  }
}

export const fontFamily =
  '"Inter", "Rubik", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';
export const fontFamilyRubik =
  '"Rubik", "Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, sans-serif';

export const typography = {
  fontFamily,
  fontWeightRegular: 400,
  fontWeightMedium: 500,
  fontWeightSemiBold: 600,
  fontWeightBold: 700,
  h1: { fontWeight: 800, lineHeight: 80 / 64, ...responsiveFontSizes({ sm: 40, md: 44, lg: 48 }) },
  h2: { fontWeight: 800, lineHeight: 64 / 48, ...responsiveFontSizes({ sm: 34, md: 38, lg: 40 }) },
  h3: { fontWeight: 700, lineHeight: 1.5, ...responsiveFontSizes({ sm: 26, md: 30, lg: 32 }) },
  h4: { fontWeight: 700, lineHeight: 1.5, ...responsiveFontSizes({ sm: 20, md: 22, lg: 24 }) },
  h5: { fontWeight: 700, lineHeight: 1.5, ...responsiveFontSizes({ sm: 18, md: 20, lg: 20 }) },
  h6: { fontWeight: 700, lineHeight: 28 / 18, ...responsiveFontSizes({ sm: 16, md: 18, lg: 18 }) },
  subtitle1: {
    fontWeight: 600,
    lineHeight: 1.5,
    ...responsiveFontSizes({ sm: 14, md: 16, lg: 16 }),
  },
  subtitle2: {
    fontWeight: 600,
    lineHeight: 22 / 14,
    ...responsiveFontSizes({ sm: 12, md: 14, lg: 14 }),
  },
  body1: { lineHeight: 1.5, ...responsiveFontSizes({ sm: 14, md: 16, lg: 16 }) },
  body2: { lineHeight: 22 / 14, ...responsiveFontSizes({ sm: 12, md: 14, lg: 14 }) },
  caption: { lineHeight: 1.5, ...responsiveFontSizes({ sm: 12, md: 12, lg: 12 }) },
  overline: {
    fontWeight: 700,
    lineHeight: 1.5,
    ...responsiveFontSizes({ sm: 12, md: 12, lg: 12 }),
  },
  button: {
    fontWeight: 700,
    lineHeight: 24 / 14,
    ...responsiveFontSizes({ sm: 14, md: 14, lg: 14 }),
  },
} as const;
